import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";
import { EmailTemplate } from "../models/EmailTemplate";

export const SEND_TEST_EMAIL_TEMPLATE = "SEND_TEST_EMAIL_TEMPLATE";
export const SEND_TEST_EMAIL_TEMPLATE_SUCCESS =
  "SEND_TEST_EMAIL_TEMPLATE_SUCCESS";
export const SEND_TEST_EMAIL_TEMPLATE_FAIL = "SEND_TEST_EMAIL_TEMPLATE_FAIL";

export interface SendTestEmailTemplateAction extends Action {
  type: typeof SEND_TEST_EMAIL_TEMPLATE;
  organization: OrganizationKeyName;
  data: Partial<EmailTemplate>;
}

export interface SendTestEmailTemplateSuccessAction extends Action {
  type: typeof SEND_TEST_EMAIL_TEMPLATE_SUCCESS;
  organization: OrganizationKeyName;
}

export interface SendTestEmailTemplateFailAction extends Action {
  type: typeof SEND_TEST_EMAIL_TEMPLATE_FAIL;
  organization: OrganizationKeyName;
}

export const sendTestEmailTemplateAction = (
  organization: OrganizationKeyName,
  data: Partial<EmailTemplate>
): SendTestEmailTemplateAction => ({
  type: SEND_TEST_EMAIL_TEMPLATE,
  organization,
  data,
});

export const sendTestEmailTemplateSuccessAction = (
  organization: OrganizationKeyName
): SendTestEmailTemplateSuccessAction => ({
  type: SEND_TEST_EMAIL_TEMPLATE_SUCCESS,
  organization,
});

export const sendTestEmailTemplateFailAction = (
  organization: OrganizationKeyName
): SendTestEmailTemplateFailAction => ({
  type: SEND_TEST_EMAIL_TEMPLATE_FAIL,
  organization,
});
